import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => {
  return {
    iconButton: {
      padding: 0,
    },
  };
});
